import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-modal-confirm',
    templateUrl: './modal-confirm.component.html',
    standalone: false,
})
export class ModalConfirmComponent {
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() description: string;
    @Input() confirmButtonText = 'Confirm';
    @Input() cancelButtonText = 'Cancel';

    onCancel(): void {
        this.closeForm(false);
    }

    onConfirm(): void {
        this.closeForm(true);
    }

    closeForm(confirmed: boolean): void {
        this.closeModal.emit(confirmed);
    }
}
